import * as yup from 'yup'

export const margensSchema = yup.object().shape({
  margemConsignado: yup
    .string()
    .test(
      'is-valid-money',
      'Valor inválido para margem consignado',
      (value) => {
        return value === '' || !isNaN(Number(value))
      }
    ),
  margemCartaoConsignado: yup
    .string()
    .test(
      'is-valid-money',
      'Valor inválido para margem cartão consignado',
      (value) => {
        return value === '' || !isNaN(Number(value))
      }
    ),
  margemCartaoBeneficio: yup
    .string()
    .test(
      'is-valid-money',
      'Valor inválido para margem cartão benefício',
      (value) => {
        return value === '' || !isNaN(Number(value))
      }
    )
})
